import {defineStore} from 'pinia'
import CustomStore from "devextreme/data/custom_store";
import { useKgbPrediksiListStore } from "@/stores/views/kgb-prediksi-list-store";
import _ from "lodash";
import axios from "axios";
import {API_BASE_URL} from "@/global-constants";
import api from "@/api";
import { useRoute } from "vue-router";
export const useKgbPrediksiListModel  = defineStore(
    'kgbPrediksiListModel',
    () => {
        const route = useRoute();
        function convertColumnName(name, columns) {
            for (const column of columns) {
                const pattern = new RegExp(`^${column}_`);
                if (pattern.test(name)) {
                    return name.replace(pattern, `${column}.`);
                }
            }
            return name;
        }
        
        function convertArrayElements(arr, columns) {
            return _.map(arr, element => {
                if (_.isArray(element)) {
                    return convertArrayElements(element, columns);
                } else if (_.isString(element)) {
                    return convertColumnName(element, columns);
                }
                return element;
            });
        }

       
        

         async function kgbPrediksiListArray(filter = null, sort = null){
        let params = {};
        params.sort = JSON.stringify(sort);
        params.filter = JSON.stringify(filter);
        const response = await axios.get(`${API_BASE_URL}/customstore-simpeg-kgb-prediksis`, {
            params: params,
            headers: {
                Authorization: api.defaults.headers.common['Authorization'],
                'Content-Type': 'application/json',
            },
        });
        if (response.data) {
            return {
                data: response.data.data,
                totalCount: response.data.totalCount,
            };
        }
        throw 'Data loading error';
        
       }

  

       async function kgbPrediksiTetapkan(key = null){
               try {
             
                const response = await axios.post(`${API_BASE_URL}/tetapkan_kgb_prediksi`, {pegawai_id: key}, {
                    headers: {
                        Authorization: api.defaults.headers.common['Authorization'],
                        'Content-Type': 'application/json',
                    },
                });
                if (response.data) {
                    return response.data;
                }
            } catch (error) {
                console.error('Insert error:', error);
                return error.response.data;
                // throw JSON.stringify(error.response.data.message, null, 2);
         
            }
        
       }

       async function kgbPrediksiSinkron(key = null){
               try {
             
                const response = await axios.post(`${API_BASE_URL}/sinkron_kgb_prediksi`, {pegawai_id: key}, {
                    headers: {
                        Authorization: api.defaults.headers.common['Authorization'],
                        'Content-Type': 'application/json',
                    },
                });
                if (response.data) {
                    return response.data;
                }
            } catch (error) {
                console.error('Insert error:', error);
                return error.response.data;
                // throw JSON.stringify(error.response.data.message, null, 2);
         
            }
        
       }



       async function kgbPrediksiListUpdate(key = null, values = null){
        values = convertArrayTgl(values);
               try {
                const response = await axios.post(`${API_BASE_URL}/customstore-simpeg-kgb-prediksis/insert`, {values : values, id : key}, {
                    headers: {
                        Authorization: api.defaults.headers.common['Authorization'],
                        'Content-Type': 'application/json',
                    },
                });
                if (response.data) {
                    return response.data;
                }
            } catch (error) {
                console.error('Insert error:', error);
                return error.response.data;
                // throw JSON.stringify(error.response.data.message, null, 2);
         
            }
        
       }



        const kgbPrediksiListCustomStore = new CustomStore({
            key: 'simpeg_kgb_prediksis_id',
            load: async (loadOptions) => {
                const columns = ['simpeg_pegawais','status_aktifs', 'simpeg_kgbs', 'simpeg_kgb_prediksis', 'gaji_pokok_kgb', 'gaji_pokok_prediksi'
                ] ;
             

                const kgbPrediksiListStore = useKgbPrediksiListStore();
                let params = {};
                params.sort = "";params.filter="";
                if (loadOptions.sort) {
                    if (typeof loadOptions.sort[0].selector === 'function') {
                        loadOptions.sort[0].selector= loadOptions.sort[0].selector.context.column.dataField;
                    }
                    params.sort = JSON.stringify(convertArrayElements(loadOptions.sort, columns));
                }
               
                
                if (loadOptions.filter) {
                    loadOptions.filter = processLoadArray(loadOptions.filter); //benerin format tanggal
                    let temp = [];
                    if(route.query.filter && kgbPrediksiListStore.state){
                 
                       temp = route.query.filter;
                    }else{
             
                        temp = removeFilterCriteria( loadOptions.filter, 'pegawai_id');
                    }
                    temp = convertArrayElements(loadOptions.filter, columns)
                    params.filter = JSON.stringify(temp);

                }


               // ================FILTER DEFAULT --> filter pegawai yang aktif
                loadOptions.filterDefault = [];
                // loadOptions.filterDefault = ['show', '=', true];
                if(params.filter === ""){
                    loadOptions.filterDefault.push(['simpeg_pegawais.status_aktif_id', '=', '1']);
                }
               
                
                params.filterDefault = JSON.stringify(loadOptions.filterDefault );

                //================SORT DEFAULT --> sort jabatan_id asc, nik
                loadOptions.sortDefault = [];
                // if(!params.sort.includes("jabatans.nama")){
                //     loadOptions.sortDefault.push({"selector":"jabatans.id","desc":false});
                // }
                // if(!params.sort.includes("nik")){
                //     loadOptions.sortDefault.push({"selector":"nik","desc":false});
                // }
                const hasOnlyTableId = loadOptions.sort && loadOptions.sort.length === 1 && _.get(loadOptions.sort[0], 'selector') === 'simpeg_kgb_prediksis_id';

                if(params.sort === "" || hasOnlyTableId){
                    loadOptions.sortDefault.push({"selector":"simpeg_kgbs.tgl","desc":true});
                    params.sort = "";
                }
                    
                    
                params.sortDefault = JSON.stringify(loadOptions.sortDefault );

                ////////////////////////////////////

                if (loadOptions.skip) {
                    params.skip = loadOptions.skip;
                }

                if (loadOptions.take) {
                    params.take = loadOptions.take;
                }

               

                const response = await axios.get(`${API_BASE_URL}/customstore-simpeg-kgb-prediksis`, {
                    params: params,
                    headers: {
                        Authorization: api.defaults.headers.common['Authorization'],
                        'Content-Type': 'application/json',
                    },
                });

                
        
          
              
                if (response.data) {

                  
                
                    return {
                        data: response.data.data,
                        totalCount: response.data.totalCount,
               
                    };
                }

                throw 'Data loading error';
            },
        });

        function removeFilterCriteria(filter, field) {
            // Check if filter is an array
            if (Array.isArray(filter)) {
              // Check if filter is a single array condition and matches the field criteria
              if (filter.length >= 3 && filter[0] === field) {
                return []; // Return an empty array to remove this filter condition
              } else {
                // Filter out sub-filters that match the field to remove
                return filter.filter(subFilter => {
                  // Recursively apply the function to nested arrays
                  if (Array.isArray(subFilter)) {
                    return removeFilterCriteria(subFilter, field).length > 0; // Keep if not empty after filtering
                  }
                  // Keep other elements (like 'and', 'or', etc.)
                  return true;
                }).map(subFilter => {
                  // Recursively apply the function to nested arrays
                  if (Array.isArray(subFilter)) {
                    return removeFilterCriteria(subFilter, field);
                  }
                  return subFilter;
                });
              }
            }
            // Return the filter as-is if it's not an array or doesn't match the expected structure
            return filter;
          }
          
       

        function processLoadArray(loadArray) {
            return _.map(loadArray, item => {
                if (_.isArray(item)) {
                    // Check if 'periode_absen' is present in the sub-array
                    if (_.includes(item, 'tgl_mulai_bekerja') || _.includes(item, 'tgl_lahir') || _.includes(item, 'pensiun_tgl')) {
                        // Map through the sub-array to find and convert Date objects
                        return _.map(item, subItem => {
                            return subItem instanceof Date ? formatDateToISOString(subItem) : subItem;
                        });
                    } else {
                        // Recursively process nested arrays
                        return processLoadArray(item);
                    }
                }
                return item;
            });
        }


        function formatDateToISOString(date) {
            function pad(n) { return n < 10 ? '0' + n : n }
            return date.getFullYear() + '-' +
                pad(date.getMonth() + 1) + '-' +
                pad(date.getDate());
        }


        function convertArrayTgl(loadArray) {
            
            _.forEach(loadArray, (item, index) => {
                if(item instanceof Date){
                     loadArray[index]= formatDateToISOString(item);
                }
                
              });
    
              return loadArray;
        }

        return {
            kgbPrediksiListCustomStore,
            kgbPrediksiListArray,
            kgbPrediksiListUpdate,
            kgbPrediksiTetapkan,
            kgbPrediksiSinkron
           
        }
    });